/* file description */

import React, { useEffect, useState, useRef } from 'react';
import './index.less';
import { loadMicroApp, MicroApp } from 'qiankun';
import * as uuid from 'uuid';

const id = uuid.v4();

export interface SpQiankunPropsType {
  routeUrl: string;
  saveCb: (tag: boolean, result: any) => void;
  qiankun?: any;
  modal?: boolean;
}

const SpQiankun: React.FC<SpQiankunPropsType> = function SpQianKun(props) {
  const { routeUrl, modal = false } = props;

  let routeUrlInfo = routeUrl;

  if (modal) {
    const tag = routeUrlInfo?.includes('?');
    const isShowTag = !routeUrlInfo?.includes('SHOWTYPE');
    if (isShowTag) {
      routeUrlInfo += `${tag ? '&' : '?'}SHOWTYPE=modal`;
    }
  }
  console.log('SPQiankun route: ', routeUrlInfo);

  const routeArray = routeUrlInfo.slice(1).split('/');
  const microAppName = routeArray.splice(0, 1)[0];
  const route = `/${routeArray.join('/')}`;

  const entry = `${location.origin}/${microAppName}/index.html`;
  // if (process.env.NODE_ENV === 'development') {
  //   entry = 'http://local.xuelei.com:5556';
  // }

  const [microApp, setMicroApp] = useState<MicroApp | undefined>();
  const [containerId] = useState<string>(`sp-qiankun-micro-app-${id}`);

  useEffect(() => {
    (async () => {
      if (!route) return;

      if (microApp?.unmount) {
        await microApp?.unmount();
      }
      const lcpMicroApp = loadMicroApp(
        {
          container: `#${containerId}`,
          name: uuid.v4(),
          entry,
          props: {
            pageConfig: {
              route,
            },
            qiankun: props.qiankun,
            saveSuccess: (result, values) => {
              props?.saveCb(true, result, values);
            },
            saveFail: (result, values) => {
              props?.saveCb(false, result, values);
            },
          },
        },
        {
          // @ts-ignore
          fetch: async (url, ...args) => {
            // @ts-ignore
            if (url?.endsWith('/static/cui/css/1.0.0/cui.min.css')) {
              return {
                async text() {
                  return '';
                },
              };
            }
            return window.fetch(url, ...args);
          },
        },
      );
      setMicroApp(lcpMicroApp);
    })();

    return () => {
      microApp?.unmount();
    };
  }, [routeUrl]);


  // 防抖处理render
  // const { run } = useDebounceFn(
  //   (value) => {
  //     console.log(value, 'valuevalue');

  //     microApp?.update && microApp.update({
  //       scenePageOptions: value
  //     })
  //   },
  //   {
  //     wait: 1000,
  //   },
  // );

  // useUpdateEffect(() => {
  //   console.log(options, 'optionsoptions');

  //   run(options)
  // }, [options])

  return (
    <div
      id={containerId}
      className="sp-qiankun-micro-app"
    />
  );
};

export default SpQiankun;
